import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SystemIcon } from '@monorepo/nova-icons';
import { StyledSearchInput, StyledSearchWrapper } from '../styled';

interface SupportedSymbolsSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const SupportedSymbolsSearch: FC<SupportedSymbolsSearchProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation(['keyMetrics']);

  return (
    <StyledSearchWrapper>
      <StyledSearchInput
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('keyMetrics:supportedSymbols.searchPlaceholder')}
        endAdornment={
          <SystemIcon iconName="Search" size={18} color="inherit" />
        }
      />
    </StyledSearchWrapper>
  );
};
